import DuckEntityForm from "ducks/DuckEntityForm";
import DuckEntity from "ducks/DuckEntity";

const paymentPlanSchedules = new DuckEntity('paymentPlanSchedules');
const paymentPlanSchedulesForm = new DuckEntityForm('paymentPlanSchedulesForm', paymentPlanSchedules, {});



export {paymentPlanSchedules, paymentPlanSchedulesForm};
